
import { useState } from 'react';
import { SharedLink } from '@/types';
import { useFamilyStore } from '@/store/familyStore';
import { useAuthStore } from '@/store/authStore';

export function useSharedLinks() {
  const user = useAuthStore((state) => state.user);
  const { 
    sharedLinks = [], 
    createSharedLink, 
    updateSharedLink, 
    deleteSharedLink 
  } = useFamilyStore();
  
  const [linkToDelete, setLinkToDelete] = useState<string | null>(null);
  const [copiedLinkId, setCopiedLinkId] = useState<string | null>(null);
  const [newLinkId, setNewLinkId] = useState<string | null>(null);
  const [showCreateDialog, setShowCreateDialog] = useState<'add' | 'info' | null>(null);

  const handleCreateLink = (targetId: string, oneTime: boolean) => {
    if (!user?.role === 'admin' || !showCreateDialog) return;

    const link = createSharedLink(showCreateDialog, targetId, oneTime);
    const baseUrl = window.location.origin;
    const path = showCreateDialog === 'add' ? 'add' : 'info';
    const fullUrl = `${baseUrl}/shared/${path}/${link.token}`;
    navigator.clipboard.writeText(fullUrl);
    
    setNewLinkId(link.id);
    setTimeout(() => setNewLinkId(null), 3000);
    setShowCreateDialog(null);
  };

  const handleCopyLink = (link: SharedLink) => {
    const url = `${window.location.origin}/shared/${link.type}/${link.token}`;
    navigator.clipboard.writeText(url);
    setCopiedLinkId(link.id);
    setTimeout(() => setCopiedLinkId(null), 2000);
  };

  const handleToggleStatus = (linkId: string, currentStatus: boolean) => {
    if (user?.role === 'admin') {
      updateSharedLink(linkId, { isActive: !currentStatus });
    }
  };

  const handleDeleteLink = () => {
    if (linkToDelete && user?.role === 'admin') {
      deleteSharedLink(linkToDelete);
      setLinkToDelete(null);
    }
  };

  // Sort links by creation date
  const sortedLinks = [...sharedLinks].sort((a, b) => b.createdAt - a.createdAt);

  return {
    user,
    sortedLinks,
    linkToDelete,
    copiedLinkId,
    newLinkId,
    showCreateDialog,
    setLinkToDelete,
    setShowCreateDialog,
    handleCreateLink,
    handleCopyLink,
    handleToggleStatus,
    handleDeleteLink,
  };
}
